module.exports = __webpack_public_path__ + "static/media/W18-0468_AW_mobile_hero_egger_fr.950f2b94.jpg";